import type { ItineraryProduct } from '@/types/products';

/* Typescript will not understand that the product is an excursion by just checking the .type,
 so we need to create a type guard */
export function isExcursion(product: ItineraryProduct): product is ItineraryProduct & { type: 'excursion' } {
  return product.type.toLowerCase() === 'excursion';
}
